import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import Select from 'react-select';
const { proxy } = require('../../ip_api.config')

class Flim_TempItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            arr_save: [],
            showItem: ''
        }
        this.onDelete = this.onDelete.bind(this)
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            console.log('arr_save', this.props.location.state.arr_item)
            this.setState({
                arr_save: this.props.location.state.arr_item
            }, () => {
                this.getOption()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getOption = async (Product) => {
        console.log('Product', Product)
        this.setState({ isLoading: true })
        let option_itemG2 = await this.get_option_itemG2()
        let option_itemG3 = await this.get_option_itemG3()
        let option_ibrand1 = await this.get_option_ibrand1()
        let option_ibrand2 = await this.get_option_ibrand2()

        this.setState({
            option_itemG2: option_itemG2,
            option_itemG3: option_itemG3,
            option_ibrand1: option_ibrand1,
            option_ibrand2: option_ibrand2,
            isLoading: false,
        }, () => { this.set_arrItemSave() })
    }

    get_option_itemG2 = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_itemG2'
        let arr = []
        arr.push(
            { value: '', label: 'None' }
        )
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log('responseJson', responseJson.result)
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            // <option value={val.description}>{val.description}</option>
                            { value: val.description, label: val.description }
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_itemG3 = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_itemG3'
        let arr = []
        arr.push(
            { value: '', label: 'None' }
        )
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                type: '',
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log('responseJson', responseJson.result)
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            // <option value={val.description}>{val.description}</option>
                            { value: val.description, label: val.description }
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_ibrand1 = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_ibrand1'
        let arr = []
        arr.push(
            { value: '', label: 'None' }
        )
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        if (val.description !== 'ABLEMEN') {
                            arr.push(
                                // <option value={val.description}>{val.description}</option>
                                { value: val.description, label: val.description }
                            )
                        }
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_ibrand2 = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_ibrand2'
        let arr = []
        arr.push(
            { value: '', label: 'None' }
        )
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                type: '',
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            // <option value={val.description}>{val.description}</option>
                            { value: val.description, label: val.description }
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_dataStandrad = async (itemG1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataStandrad'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("get_dataStandrad", responseJson.result[0])
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    get_dataWarehourse = async (itemG1, dbname) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataWarehourse'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1,
                dbname: dbname
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("get_dataWarehourse", responseJson.result)
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    get_dataFocusTrade = async (type, itemG3, ibrand1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataFocusTrade'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                type_product: type === 'Focus' ? 'Focus/Trade' : type,
                itemG3: itemG3,
                ibrand1: ibrand1
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("get_dataFocusTrade", responseJson.result)
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    get_itemG1 = async (itemG1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_itemG1'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("get_itemG1", responseJson.result)
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    set_arrItemSave = async () => {
        this.setState({ isLoading: true })

        const { arr_save } = this.state
        let arr = []

        arr = await Promise.all(arr_save.map(async function (val, i) {
            console.log('description', val.description.charAt(0))
            console.log('description', val.description.substr(1))
            let dataStandrad = await this.get_dataStandrad(val.name.substr(0, 3))
            let dataWearhouse = await this.get_dataWarehourse(val.name.substr(0, 3), val.dbname)
            let dataFocusTrade
            if (val.product_type === 'Other') {
                dataFocusTrade = await this.get_dataFocusTrade(val.product_type, val.name.substr(0, 4), '')
            } else {
                dataFocusTrade = await this.get_dataFocusTrade(val.product_type, val.itemG3, val.ibrand1)
            }

            let itemG1_description = await this.get_itemG1(val.name.substr(0, 3))
            // console.log("dataWearhouse", dataWearhouse)

            let itemG1 = val.product_type === 'Focus' || val.product_type === 'Ablemen' ? val.name.substr(0, 3)
                : val.product_type === 'Other' ? val.name.charAt(0) === 'R' ? 'RM' : val.name.substr(0, 3) : ''


            let itemG3 = val.product_type === 'Focus' || val.product_type === 'Ablemen' ? val.itemG3
                : val.product_type === 'Other' ? itemG1 === 'RM' ? val.name.substr(0, 4) : '' : ''

            let buyerGoup = itemG1 === 'G08' || itemG1 === 'G05'
                || itemG1 === 'G0A' || itemG1 === 'S05' || itemG1 === 'TAB' ? ''
                : itemG1 === 'S08' ? 'CN' : itemG1 === 'T0A' ? 'CN-FAC'
                    : itemG1 === 'S0A' && itemG3 === 'TG-UC' ? 'CN-FAC'
                        : itemG1 === 'S0A' && itemG3 === 'HR-CL' ? 'CN-FAC'
                            : itemG1 === 'S0A' && itemG3 === 'TG-FF HD' ? 'CN-FAC'
                                : itemG1 === 'S0A' && itemG3 === 'HR-FF' ? 'CN-FAC'
                                    : itemG1 === 'S0A' ? 'CN' : val.name.substr(0, 1) === 'R' ? 'CN' : ''

            // let itemG2 = val.product_type === 'Focus' || val.product_type === 'Ablemen' ? val.ibrand1
            //     : val.name.substr(0, 2) === 'RF' ? 'RM-FILM'
            //         : val.name.substr(0, 2) === 'RA' ? 'RM-AB'
            //             : val.name.substr(0, 2) === 'RT' ? 'RM-TG'
            //                 : val.name.substr(0, 5)

            let itemG2 = val.name.substr(0, 1) === 'P' || val.name.substr(0, 1) === 'U' ? val.name.substr(0, 5) :
                dataFocusTrade === undefined || dataFocusTrade === null ? '' : dataFocusTrade.itemG2

            let status_item = val.product_type === 'Other' ? 1
                : itemG1 === 'G08' || itemG1 === 'G0A' ? 0
                    : itemG1 === 'G05' ? 1
                        : ''

            this.state.arr_save[i].buyerGoup = buyerGoup
            this.state.arr_save[i].itemG1 = itemG1
            this.state.arr_save[i].itemG2 = itemG2
            this.state.arr_save[i].itemG3 = itemG3
            this.state.arr_save[i].status_item = status_item
            this.state.arr_save[i].itemG1_des = itemG1_description === undefined || itemG1_description === null ? '' : itemG1_description.description
            this.state.arr_save[i].itemG2_des = dataFocusTrade === undefined || dataFocusTrade === null ? '' : dataFocusTrade.itemG2

            this.state.arr_save[i].unit_Collect = dataStandrad === undefined || dataStandrad.InventTableModuleInvent_UnitId === null ? '' : dataStandrad.InventTableModuleInvent_UnitId
            this.state.arr_save[i].unit_Buy = dataStandrad === undefined || dataStandrad.InventTableModulePurch_UnitId === null ? '' : dataStandrad.InventTableModulePurch_UnitId
            this.state.arr_save[i].unit_Sale = dataStandrad === undefined || dataStandrad.InventTableModuleSales_UnitId === null ? '' : dataStandrad.InventTableModuleSales_UnitId
            this.state.arr_save[i].DefaultOrderType = dataStandrad === undefined || dataStandrad.DefaultOrderType === null ? '' : dataStandrad.DefaultOrderType
            this.state.arr_save[i].EcoResTrackingDimensionGroup_Name = dataStandrad === undefined || dataStandrad.EcoResTrackingDimensionGroup_Name === null ? '' : dataStandrad.EcoResTrackingDimensionGroup_Name
            this.state.arr_save[i].ItemGroupId = dataStandrad === undefined || dataStandrad.ItemGroupId === null ? '' : dataStandrad.ItemGroupId
            this.state.arr_save[i].CostGroupId = dataStandrad === undefined || dataStandrad.CostGroupId === null ? '' : dataStandrad.CostGroupId
            this.state.arr_save[i].BatchNumGroupId = dataStandrad === undefined || dataStandrad.BatchNumGroupId === null ? '' : dataStandrad.BatchNumGroupId
            this.state.arr_save[i].SerialNumGroupId = dataStandrad === undefined || dataStandrad.SerialNumGroupId === null ? '' : dataStandrad.SerialNumGroupId
            this.state.arr_save[i].InventTableModuleInvent_UnitId = dataStandrad === undefined || dataStandrad.InventTableModuleInvent_UnitId === null ? '' : dataStandrad.InventTableModuleInvent_UnitId
            this.state.arr_save[i].InventTableModulePurch_UnitId = dataStandrad === undefined || dataStandrad.InventTableModulePurch_UnitId === null ? '' : dataStandrad.InventTableModulePurch_UnitId
            this.state.arr_save[i].InventTableModulePurch_OverDeliveryPct = dataStandrad === undefined || dataStandrad.InventTableModulePurch_OverDeliveryPct === null ? '' : dataStandrad.InventTableModulePurch_OverDeliveryPct
            this.state.arr_save[i].InventTableModulePurch_UnderDeliveryPct = dataStandrad === undefined || dataStandrad.InventTableModulePurch_UnderDeliveryPct === null ? '' : dataStandrad.InventTableModulePurch_UnderDeliveryPct
            this.state.arr_save[i].InventTableModuleSales_UnitId = dataStandrad === undefined || dataStandrad.InventTableModuleSales_UnitId === null ? '' : dataStandrad.InventTableModuleSales_UnitId
            this.state.arr_save[i].ECL_NumberSequenceGroupProd = dataStandrad === undefined || dataStandrad.ECL_NumberSequenceGroupProd === null ? '' : dataStandrad.ECL_NumberSequenceGroupProd
            this.state.arr_save[i].BOMUnitId = dataStandrad === undefined || dataStandrad.BOMUnitId === null ? '' : dataStandrad.BOMUnitId
            this.state.arr_save[i].DefaultDimension = dataStandrad === undefined || dataStandrad.DefaultDimension === null ? '' : dataStandrad.DefaultDimension

            this.state.arr_save[i].PurchInventLocationId = dataWearhouse === undefined || dataWearhouse.PurchInventLocationId === null ? '' : dataWearhouse.PurchInventLocationId
            this.state.arr_save[i].ItemInventLocationId = dataWearhouse === undefined || dataWearhouse.ItemInventLocationId === null ? '' : dataWearhouse.ItemInventLocationId
            this.state.arr_save[i].SalesInventLocationId = dataWearhouse === undefined || dataWearhouse.SalesInventLocationId === null ? '' : dataWearhouse.SalesInventLocationId

            // return true
        }, this))

        this.setState({ arr_save: this.state.arr_save }, () => this.show_arrItemSave())
    }

    show_arrItemSave = async () => {
        this.setState({ isLoading: true })

        const { arr_save } = this.state
        let arr
        let arrDPL = []
        let arrDFIX = []
        let arrDPT = []

        // console.log('show_arrItemSave', arr_save)
        arr_save.map(async function (val, i) {
            if (val.dbname === 'DPL') {
                arrDPL.push(<tr key={val.name + val.dbname}>
                    <td><bs4.Button color='danger' size='sm' style={{ fontSize: 14 }} onClick={() => this.onDelete(val.dbname, val.name)}>DEL</bs4.Button></td>
                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.dbname}</td>
                    {val.name.length > 20
                        ? <td style={{ color: 'red' }}>
                            ***ขนาดเกิน 20 ตัวอักษร
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.name} />
                            </bs4.Col>
                        </td>
                        : <td>
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="text" name="name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.name} />
                            </bs4.Col>
                        </td>
                    }
                    {val.description.length > 60
                        ? <td style={{ color: 'red' }}>
                            ***ขนาดเกิน 60 ตัวอักษร
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                            </bs4.Col>
                        </td>
                        :
                        <td>
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                            </bs4.Col>
                        </td>
                    }
                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="text" name="gross_width" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.gross_width} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="text" name="gross_height" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.gross_height} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="line_discount_group" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.line_discount_group} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="itemG4" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.itemG4} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand3" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand3} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand3_des" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand3_des} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand4_code" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand4_code} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="select" name="buyerGoup" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.buyerGoup}>{val.buyerGoup === '' ? '-----' : val.buyerGoup}</option>
                                <option value='CN'>CN</option>
                                <option value='CN-FAC'>CN-FAC</option>
                                <option value='TH'>TH</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>{val.itemG1}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            {/* <bs4.Input type="select" name="itemG2" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.itemG2}>{val.itemG2 === '' ? '-----' : val.itemG2}</option>
                                {this.state.option_itemG2}
                            </bs4.Input> */}
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "itemG2", e.value))}
                                options={this.state.option_itemG2}
                                placeholder={val.itemG2 === '' ? 'None' : val.itemG2}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            {/* <bs4.Input type="select" name="itemG3" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.itemG3}>{val.itemG3 === '' ? '-----' : val.itemG3}</option>
                                {this.state.option_itemG3}
                            </bs4.Input> */}
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "itemG3", e.value))}
                                options={this.state.option_itemG3}
                                placeholder={val.itemG3 === '' ? 'None' : val.itemG3}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            {/* <bs4.Input type="select" name="ibrand1" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.ibrand1}>{val.ibrand1 === '' ? '-----' : val.ibrand1}</option>
                                {this.state.option_ibrand1}
                            </bs4.Input> */}
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "ibrand1", e.value))}
                                options={this.state.option_ibrand1}
                                placeholder={val.ibrand1 === '' ? 'None' : val.ibrand1}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            {/* <bs4.Input type="select" name="ibrand2" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.ibrand2}>{val.ibrand2 === '' ? '-----' : val.ibrand2}</option>
                                {this.state.option_ibrand2}
                            </bs4.Input> */}
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "ibrand2", e.value))}
                                options={this.state.option_ibrand2}
                                placeholder={val.ibrand2 === '' ? 'None' : val.ibrand2}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="select" name="status_item" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.status_item}>{val.status_item === '' ? '-----' : val.status_item}</option>
                                <option value={0}>0</option>
                                <option value={1}>1</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>{val.InventTableModuleInvent_UnitId}</td>
                    <td>{val.InventTableModulePurch_UnitId}</td>
                    <td>{val.InventTableModuleSales_UnitId}</td>
                </tr >)
            } else if (val.dbname === 'DFIX') {
                arrDFIX.push(<tr key={val.name + val.dbname}>
                    <td><bs4.Button color='danger' size='sm' style={{ fontSize: 13 }} onClick={() => this.onDelete(val.dbname, val.name)}>DEL</bs4.Button></td>
                    <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.dbname}</td>
                    {val.name.length > 20
                        ? <td style={{ color: 'red' }}>
                            ***ขนาดเกิน 20 ตัวอักษร
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.name} />
                            </bs4.Col>
                        </td>
                        : <td>
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="text" name="name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.name} />
                            </bs4.Col>
                        </td>
                    }
                    {val.description.length > 60
                        ? <td style={{ color: 'red' }}>
                            ***ขนาดเกิน 60 ตัวอักษร
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                            </bs4.Col>
                        </td>
                        :
                        <td>
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                            </bs4.Col>
                        </td>
                    }

                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="text" name="gross_width" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.gross_width} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="text" name="gross_height" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.gross_height} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="line_discount_group" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.line_discount_group} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="itemG4" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.itemG4} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand3" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand3} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand3_des" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand3_des} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand4_code" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand4_code} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="select" name="buyerGoup" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.buyerGoup}>{val.buyerGoup === '' ? '-----' : val.buyerGoup}</option>
                                <option value='CN'>CN</option>
                                <option value='CN-FAC'>CN-FAC</option>
                                <option value='TH'>TH</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>{val.itemG1}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "itemG2", e.value))}
                                options={this.state.option_itemG2}
                                placeholder={val.itemG2 === '' ? 'None' : val.itemG2}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "itemG3", e.value))}
                                options={this.state.option_itemG3}
                                placeholder={val.itemG3 === '' ? 'None' : val.itemG3}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "ibrand1", e.value))}
                                options={this.state.option_ibrand1}
                                placeholder={val.ibrand1 === '' ? 'None' : val.ibrand1}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "ibrand2", e.value))}
                                options={this.state.option_ibrand2}
                                placeholder={val.ibrand2 === '' ? 'None' : val.ibrand2}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="select" name="status_item" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.status_item}>{val.status_item === '' ? '-----' : val.status_item}</option>
                                <option value={0}>0</option>
                                <option value={1}>1</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>{val.InventTableModuleInvent_UnitId}</td>
                    <td>{val.InventTableModulePurch_UnitId}</td>
                    <td>{val.InventTableModuleSales_UnitId}</td>
                </tr >)
            } else if (val.dbname === 'DPT') {
                arrDPT.push(<tr key={val.name + val.dbname}>
                    <td><bs4.Button color='danger' size='sm' style={{ fontSize: 13 }} onClick={() => this.onDelete(val.dbname, val.name)}>DEL</bs4.Button></td>
                    <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.dbname}</td>
                    {val.name.length > 20
                        ? <td style={{ color: 'red' }}>
                            ***ขนาดเกิน 20 ตัวอักษร
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.name} />
                            </bs4.Col>
                        </td>
                        : <td>
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="text" name="name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.name} />
                            </bs4.Col>
                        </td>
                    }
                    {val.description.length > 60
                        ? <td style={{ color: 'red' }}>
                            ***ขนาดเกิน 60 ตัวอักษร
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                            </bs4.Col>
                        </td>
                        :
                        <td>
                            <bs4.Col sm='12' style={{ width: 250 }}>
                                <bs4.Input type="textarea" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                            </bs4.Col>
                        </td>
                    }

                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="text" name="gross_width" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.gross_width} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="text" name="gross_height" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.gross_height} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="line_discount_group" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.line_discount_group} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="itemG4" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.itemG4} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand3" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand3} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand3_des" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand3_des} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand4_code" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ibrand4_code} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="select" name="buyerGoup" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.buyerGoup}>{val.buyerGoup === '' ? '-----' : val.buyerGoup}</option>
                                <option value='CN'>CN</option>
                                <option value='CN-FAC'>CN-FAC</option>
                                <option value='TH'>TH</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>{val.itemG1}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "itemG2", e.value))}
                                options={this.state.option_itemG2}
                                placeholder={val.itemG2 === '' ? 'None' : val.itemG2}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 250 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "itemG3", e.value))}
                                options={this.state.option_itemG3}
                                placeholder={val.itemG3 === '' ? 'None' : val.itemG3}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "ibrand1", e.value))}
                                options={this.state.option_ibrand1}
                                placeholder={val.ibrand1 === '' ? 'None' : val.ibrand1}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItem(i, "ibrand2", e.value))}
                                options={this.state.option_ibrand2}
                                placeholder={val.ibrand2 === '' ? 'None' : val.ibrand2}
                            />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 100 }}>
                            <bs4.Input type="select" name="status_item" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.status_item}>{val.status_item === '' ? '-----' : val.status_item}</option>
                                <option value={0}>0</option>
                                <option value={1}>1</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>{val.InventTableModuleInvent_UnitId}</td>
                    <td>{val.InventTableModulePurch_UnitId}</td>
                    <td>{val.InventTableModuleSales_UnitId}</td>
                </tr >)
            }

        }, this)

        arr = arrDPL.concat(arrDPT, arrDFIX)

        this.setState({ isLoading: false, showItem: arr })
    }

    handleChangeItem = (index, name, value) => {
        // console.log('index', index)
        // console.log('name', name)
        // console.log('value', value)
        if (index === 'a') {
            if (name === 'gross_width') {
                this.state.arr_save.map(function (val, i) {
                    val.gross_width = value
                })
            } else if (name === 'gross_height') {
                this.state.arr_save.map(function (val, i) {
                    val.gross_height = value
                })
            } else if (name === 'line_discount_group') {
                this.state.arr_save.map(function (val, i) {
                    val.line_discount_group = value
                })
            } else if (name === 'itemG4') {
                this.state.arr_save.map(function (val, i) {
                    val.itemG4 = value
                })
            } else if (name === 'ibrand3') {
                this.state.arr_save.map(function (val, i) {
                    val.ibrand3 = value
                })
            } else if (name === 'ibrand3_des') {
                this.state.arr_save.map(function (val, i) {
                    val.ibrand3_des = value
                })
            } else if (name === 'ibrand4_code') {
                this.state.arr_save.map(function (val, i) {
                    val.ibrand4_code = value
                })
            } else if (name === 'buyerGoup') {
                this.state.arr_save.map(function (val, i) {
                    val.buyerGoup = value
                })
            } else if (name === 'itemG2') {
                this.state.arr_save.map(function (val, i) {
                    val.itemG2 = value
                })
            } else if (name === 'itemG3') {
                this.state.arr_save.map(function (val, i) {
                    val.itemG3 = value
                })
            } else if (name === 'ibrand1') {
                this.state.arr_save.map(function (val, i) {
                    val.ibrand1 = value
                })
            } else if (name === 'ibrand2') {
                this.state.arr_save.map(function (val, i) {
                    val.ibrand2 = value
                })
            } else if (name === 'status_item') {
                this.state.arr_save.map(function (val, i) {
                    val.status_item = value
                })
            }
        } else if (name === 'name') {
            this.state.arr_save[index].name = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        } else if (name === 'gross_width') {
            this.state.arr_save[index].gross_width = value
        } else if (name === 'gross_height') {
            this.state.arr_save[index].gross_height = value
        } else if (name === 'line_discount_group') {
            this.state.arr_save[index].line_discount_group = value
        } else if (name === 'itemG4') {
            this.state.arr_save[index].itemG4 = value
        } else if (name === 'ibrand3') {
            this.state.arr_save[index].ibrand3 = value
        } else if (name === 'ibrand3_des') {
            this.state.arr_save[index].ibrand3_des = value
        } else if (name === 'ibrand4_code') {
            this.state.arr_save[index].ibrand4_code = value
        } else if (name === 'buyerGoup') {
            this.state.arr_save[index].buyerGoup = value
        } else if (name === 'itemG2') {
            this.state.arr_save[index].itemG2 = value
        } else if (name === 'itemG3') {
            this.state.arr_save[index].itemG3 = value
        } else if (name === 'ibrand1') {
            this.state.arr_save[index].ibrand1 = value
        } else if (name === 'ibrand2') {
            this.state.arr_save[index].ibrand2 = value
        } else if (name === 'status_item') {
            this.state.arr_save[index].status_item = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.show_arrItemSave()
        })
    }

    onDelete = (db, name) => {
        console.log('db, name', db, name)

        let arr = []

        this.state.arr_save.map(function (val, i) {
            if (val.name === name && val.dbname === db) {
                // arr_save.splice(i, 1) 
            }
            else {
                console.log('arr_save2', val)
                arr.push(val)
            }
        })


        console.log('arr_save', arr)
        this.setState({
            arr_save: arr,
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.show_arrItemSave()
        })
    }

    saveItem = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })

            let url = proxy.server + '/flim/insert_item'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(this.state.arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {

                        this.setState({ isLoading: false })

                        this.props.history.push({
                            pathname: '/Flim/PreviewItem'
                        })
                    } else {
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_CreateCode'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginBottom: 20 }}>
                    <bs4.Button color="warning" style={{ marginLeft: 20, marginRight: 20, fontWeight: 500 }} onClick={() => this.saveItem()}>SAVE ITEM</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th style={{ backgroundColor: '#FFF' }}></th>
                            <th>ฐานข้อมูล</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Code</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Name</th>
                            <th>Gross Width</th>
                            <th>Gross Height</th>
                            <th>Line Discount Group</th>
                            <th>Item G4</th>
                            <th>Ibrand3</th>
                            <th>Ibrand3 Des</th>
                            <th>Ibrand4</th>
                            <th style={{ backgroundColor: '#61ba52' }}>กลุ่มในการสั่งซือ</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Item G1</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Item G2</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Item G3</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Ibrand1</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Ibrand2</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Status Item</th>
                            <th>ระบุหน่วยจัดเก็บ</th>
                            <th>ระบุหน่วยซื้อ</th>
                            <th>ระบุหน่วยขาย</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ textAlign: 'center' }}>
                            <td style={{ width: 40 }}></td>
                            <td style={{ width: 150 }}></td>
                            <td style={{ width: 150 }}></td>
                            <td style={{ width: 150 }}></td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="gross_width" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="gross_height" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="line_discount_group" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="itemG4" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="ibrand3" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="ibrand3_des" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 200 }}>
                                    <bs4.Input type="text" name="ibrand4_code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        {this.state.showItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_TempItem